export const LOCALES = ['uk', 'en']